import Layout from '@/layouts/Layout'

const company = {
  path: '/company_new',
  component: Layout,
  name: 'company_new',
  meta: {
    title: '公司',
  },
  children: [
    {
      path: '/companyNew/companyAccount/list',
      name: 'company_new_account',
      component: () => import('@/pages/organize/companyAccount/list'),
      meta: { title: '账号管理', logEvent: '' },
    },
    {
      path: '/company/pending/list',
      name: 'company_new_affairs',
      component: () => import('@/pages/organize/pending/list/index'),
      meta: { title: '待办管理', logEvent: '' },
    },
    {
      path: '/companyNew/approveFlowConfig/list',
      name: 'company_new_approval_config',
      component: () => import('@/pages/approvals/approveFlowConfig/list'),
      meta: { title: '审批流配置', logEvent: '' },
    },
    {
      path: '/companyNew/approveFlowConfig/detail',
      name: 'company_new_approval_config_list_detail',
      component: () => import('@/pages/approvals/approveFlowConfig/detail'),
      meta: { title: '审批流配置详情', logEvent: '' },
    },
    {
      path: '/companyNew/approveFlowConfig/edit',
      name: 'company_new_approval_config_list_edit',
      component: () => import('@/pages/approvals/approveFlowConfig/edit'),
      meta: { title: '审批流配置编辑',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/approveFlowConfig/list',
            name: 'company_new_approval_config',
            title: '审批流配置',
          },
        ] },
    },
    {
      path: '/companyNew/approveList/list',
      name: 'company_new_approval_manage',
      component: () => import('@/pages/approvals/approveList/list'),
      meta: { title: '审批列表', logEvent: '' },
    },
    {
      path: '/companyNew/approveList/detail',
      name: 'company_new_approval_manage_list_detail',
      component: () => import('@/pages/approvals/approveList/detail'),
      meta: { title: '审批详情', logEvent: '' },
    },
    {
      path: '/companyNew/approveCenter/list',
      name: 'company_new_approval_center',
      component: () => import('@/pages/approvals/approveCenter/list'),
      meta: { title: '审批中心', logEvent: '' },
    },
    {
      path: '/companyNew/contractTemplate/list',
      name: 'company_new_contract_template',
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/index.vue'),
      meta: { title: '合同模板管理', logEvent: '' },
    },
    {
      path: '/companyNew/contractTemplate/edit',
      name: 'company_new_contract_template_list_edit',
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/edit.vue'),
      meta: { title: '合同模板编辑',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/contractTemplate/list',
            name: 'company_new_contract_template',
            title: '合同模板管理',
          },
        ] },
    },
    {
      path: '/companyNew/contractTemplate/add',
      name: 'company_new_contract_template_list_create',
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/add.vue'),
      meta: { title: '合同模板新增',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/contractTemplate/list',
            name: 'company_new_contract_template',
            title: '合同模板管理',
          },
        ] },
    },
    {
      path: '/companyNew/roleManage/list',
      name: 'company_new_role',
      component: () => import('@/pages/organize/roleManage/list'),
      meta: { title: '角色管理', logEvent: '' },
    },
    {
      path: '/companyNew/announcement/list',
      name: 'company_new_notice',
      component: () => import('@/pages/organize/announcement/list'),
      meta: { title: '公告管理', logEvent: '' },
    },
    {
      path: '/companyNew/announcement/add',
      name: 'company_new_notice_list_create',
      component: () => import('@/pages/organize/announcement/add'),
      meta: { title: '新增公告',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/announcement/list',
            name: 'company_new_notice',
            title: '公告管理',
          },
        ] },
    },
    {
      path: '/companyNew/announcement/edit',
      name: 'company_new_notice_list_edit',
      component: () => import('@/pages/organize/announcement/edit'),
      meta: { title: '编辑公告',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/announcement/list',
            name: 'company_new_notice',
            title: '公告管理',
          },
        ] },
    },
    // 以下是门店相关
    {
      path: '/companyNew/company/storeManage/list',
      name: 'company_store_list',
      component: () => import('@/pages/shop/store/list'),
      meta: { title: '门店列表' },
    },
    {
      path: '/companyNew/company/storeManage/add',
      name: 'company_handle_store',
      component: () => import('@/pages/shop/store/add'),
      meta: { title: '新增门店',
        parent: [
          {
            path: '/companyNew/company/storeManage/list',
            name: 'company_store_list',
            title: '门店列表',
          },
        ] },
      hidden: true,
    },
    {
      path: '/companyNew/company/storeManage/detail',
      name: 'company_store_detail',
      component: () => import('@/pages/shop/store/detail'),
      meta: { title: '门店详情' },
      hidden: true,
    },
  ],
}
export default company
